import { setupLinkHoverAnimations } from '../utils/linkAnimations';

/**
 * Initialize menu animations using the Motion library
 */
export function initMenuAnimations() {
  // Select all navigation links in the main menu
  const navLinks = document.querySelectorAll('.nav-link');

  // Don't proceed if there are no nav links
  if (navLinks.length === 0) return;

  // Set up hover animations for nav links with circle elements
  setupLinkHoverAnimations(navLinks, { circleSize: '32px' });

  // Add a class to indicate JS is loaded and working
  document.body.classList.add('menu-animations-loaded');
}

export default initMenuAnimations;
